import Collapsible from './Collapsible';
import Accordion from './Accordion';
import AccordionItem from './AccordionItem';

export default Collapsible;

export {
  Collapsible, Accordion, AccordionItem
};
